<template>
  <a-col :span="12">
    <a-form-item label="最大字符">
      <a-input-number
        v-model:value="config.maxlength"
        style="width: 100%"
        :min="1"
      />
    </a-form-item>
  </a-col>
  <a-col :span="12">
    <a-form-item label="前缀标签">
      <a-input
        v-model:value="config.addonBefore"
        allow-clear
      />
    </a-form-item>
  </a-col>
  <a-col :span="12">
    <a-form-item label="后缀标签">
      <a-input
        v-model:value="config.addonAfter"
        allow-clear
      />
    </a-form-item>
  </a-col>
</template>

<script setup lang="ts">
/* 文本类输入增强（共享）：maxlength + 前后缀标签（input/number）。
   图标型前后缀（addonBeforeIcon/addonAfterIcon）可在「JSON配置」tab 补。 */
defineProps<{ config: any }>();
</script>
